import { vars } from '../theme';

// API mantida por compatibilidade. As cores de marca agora vêm do tema
// ativo (src/theme) como CSS variables; neutras e douradas seguem fixas.
export const colors = {
    shadowLight:'rgba(0, 0, 0, 0.1)',
    black: '#000000',
    white: '#ffffff',
    primaryColor: '#343434',
    secondaryColor: vars.brand.primary,
    darkBlue: vars.brand.inkDark,
    purple: vars.brand.ink,
    goldColor: "#d6b827",
    blueColor: "#5dade2",
};

export const fontFamily = {
    primary:  `'Noto Sans', sans-serif`,
    secondary: `'Lato', sans-serif`,
}
export const DEFAULT_BUTTON_COLOR = vars.cta.bg;
